export default "__VITE_ASSET__DhHZ$Pqd__"